import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import { PublicCategory } from '../../types/public-category.type';
import HttpClient from '../../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../../shared/utils/extract-api-error-message.util';
import { PUBLIC_CATEGORIES_API_PATHS } from '../../constants/public-categories-paths.constants';

interface FindPublicCategoriesResponse {
  categories: PublicCategory[];
}

interface FindPublicCategoriesState {
  loading: boolean;
  categories: PublicCategory[];
}

export function useFindPublicCategories() {
  const { enqueueSnackbar } = useSnackbar();

  const [result, setResult] = useState<FindPublicCategoriesState>({
    loading: true,
    categories: [],
  });

  useEffect(() => {
    let cancelled = false;
    setResult({ loading: true, categories: [] });

    HttpClient.get<FindPublicCategoriesResponse>(PUBLIC_CATEGORIES_API_PATHS.GET_CATEGORIES)
      .then((response) => {
        if (!cancelled) setResult({ loading: false, categories: response.categories });
      })
      .catch((error) => {
        if (cancelled) return;
        enqueueSnackbar(
          extractApiErrorMessage(error, 'Une erreur est survenue lors de la récupération des catégories'),
          { variant: 'error' }
        );
        setResult({ loading: false, categories: [] });
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line
  }, []);

  return result;
}
